<ul class="m-0" [ngClass]="{'list-inline': inline, 'list-unstyled': !inline}">
  <li class="text-break" [ngClass]="{'list-inline-item': inline}" *ngFor="let spec of specs">
    <ng-container *ngIf="(propertiesQuery.selectEntity(spec.PropertyId) | async) as property">
      <app-spec-line-visibility-display [visibilityClv]="spec.MandatoryClv" class="me-1"></app-spec-line-visibility-display>
      <em [class.fw-light]="spec.LanguageId">{{spec.Alias || property.Name}}</em>:
      <app-spec-value-view class="text-gray-700" [spec]="spec" [property]="property"></app-spec-value-view>
    </ng-container>
  </li>
</ul>
